import * as React from 'react'

const FilesNotes = ({
  title,
  titleId,
  ...props
}: {
  title?: string
  titleId?: string
} & React.SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="#400099"
    focusable={false}
    aria-hidden
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M17 2v4h4l-4-4zm-1 0H4a1 1 0 00-1 1v18a1 1 0 001 1h16a1 1 0 001-1V7h-5V2zm-3 16H6v-1h7v1zm5-4H6v-1h12v1zm0-5v1H6V9h12z" />
  </svg>
)

export default FilesNotes
